const DESCRIPTION_MAX_LENGTH = 300

const GENDERS = {
  M: 'Мужской',
  F: 'Женский',
}

const actualText = ({ text, isCasePage }: { text: string; isCasePage?: boolean }) => {
  return text.length > DESCRIPTION_MAX_LENGTH && !isCasePage
    ? `${text.slice(0, DESCRIPTION_MAX_LENGTH)}...`
    : text
}

export { actualText, GENDERS }
